import { BulkOptionType } from 'elements/hardwareSelectorV2/types'
import { Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'
import { OpenSolarPalette } from 'Themes'
import { formatCurrencyNumber } from 'util/misc'

const HELPER_TEXT_COLOUR = OpenSolarPalette.blue45
const DISTRIBUTOR_NAME_COLOUR = OpenSolarPalette.greyMid1

const BulkPriceFrom = ({ currencySymbol, lowestPrice }: { currencySymbol: string; lowestPrice: number }) => {
  const translate = useTranslate()
  return (
    <Typography textVariant="helper1" colorHex={HELPER_TEXT_COLOUR}>
      {translate('Bulk price from')} {currencySymbol}
      {formatCurrencyNumber(lowestPrice, 2)}
    </Typography>
  )
}

type BulkPricingTextProps = {
  lowestPrice: number
  distributorNames: string[]
  currencySymbol: string
  selectedDistributorLowestBulkPrice?: number
  bulkOption: BulkOptionType | null
  isDistributorSelected: boolean
}
const BulkPricingText = ({
  lowestPrice,
  distributorNames,
  currencySymbol,
  selectedDistributorLowestBulkPrice,
  bulkOption,
  isDistributorSelected,
}: BulkPricingTextProps) => {
  const translate = useTranslate()
  // if a bulk option is selected, show the bulk price
  if (bulkOption) {
    return (
      <Typography textVariant="helper1" colorHex={HELPER_TEXT_COLOUR}>
        {currencySymbol}
        {formatCurrencyNumber(bulkOption.price_per_unit, 2)} {translate('per unit')}
      </Typography>
    )
  }
  // if a distributor is selected and there is a bulk price, show the bulk price
  if (selectedDistributorLowestBulkPrice && isDistributorSelected) {
    return <BulkPriceFrom currencySymbol={currencySymbol} lowestPrice={selectedDistributorLowestBulkPrice} />
  }

  // if a distributor is selected and there is no bulk price, show nothing
  if (isDistributorSelected) {
    return <></>
  }

  // if no distributor is selected, show the lowest price from all distributors and the distributor names
  return (
    <>
      {lowestPrice && <BulkPriceFrom currencySymbol={currencySymbol} lowestPrice={lowestPrice} />}
      {distributorNames.length > 0 && (
        <Typography textVariant="helper1" colorHex={DISTRIBUTOR_NAME_COLOUR}>
          {distributorNames.join(', ')}
        </Typography>
      )}
    </>
  )
}

export default BulkPricingText
